export default "__VITE_ASSET__CANKRZYb__"